<template>
  <div style="display:none">
    <div class="ui action left icon input">
      <i class="search icon"></i>
      <input v-model="query" placeholder="Search..." type="text">
      <div class="ui teal button" @click="addWorld">Search</div>
    </div>
    <div class="ui list">
      <div class="item" v-for="(word, index) in words" :key="index">
        <div class="ui tag teal label">
          {{word}}
          <i class="delete icon" @click="deleteWord($event)"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

/**
 * Component used to make full text search
 */
export default {
  data() {
    return {
      //The query string in the search bar
      query: "",
      //The array of word that need ot be queried
      words: []
    };
  },
  computed: {
    /**
     * Getters from Vuex filter store
     */
    ...mapGetters(["getFilters", "isFiltersEmpty"])
  },
  methods: {
    /**
     * Actions from Vuex filter and observation store
     */
    ...mapActions([
      "searchObservations",
      "setFullTextFilter",
      "resetObservations",
      "initFacets"
    ]),
    /**
     * Method triggered a word searched. The word is printed to the ui, the filters are updated
     * with the new word and new observations are queried using the updated filters
     */
    addWorld() {
      let queryTrim = this.query.trim();
      if (queryTrim !== "" && this.words.indexOf(queryTrim) === -1) {
        this.words.push(queryTrim);
        let queryParam = "";
        for (let i = 0; i < this.words.length; i++) {
          queryParam = queryParam + this.words[i] + " ";
        }
        //Update filters (async) and then query observation using the new filters
        this.setFullTextFilter(queryParam.trim()).then(() => {
          this.searchObservations(this.getFilters);
        });
        //the search bar is emptied
        this.query = "";
      }
    },

    /**
     * Method triggered when the word searched is deleted by the user. The word is deleted from the UI,
     * the filters are updated and observations are queried using the new filters
     */
    deleteWord(event) {
      // the word to delete
      let word = event.currentTarget.parentElement.innerText.trim();
      //the word is deleted from words array
      this.words.splice(this.words.indexOf(word.valueOf()), 1);
      let queryParam = "";
      // a query param is formed using the words array
      for (let i = 0; i < this.words.length; i++) {
        queryParam = queryParam + this.words[i] + " ";
      }
      //If the queryParam is empty, the filters are updated and the facet are reseted using the whole database
      //full text filter is set to null!
      if (queryParam.trim() === "") {
        this.setFullTextFilter(null).then(() => {
          if (this.isFiltersEmpty) {
            this.resetObservations();
            this.initFacets();
          } else {
            this.searchObservations(this.getFilters);
          }
        });
      } 
      // if the queryParam string is not emtpy the filter are updated and observations are queried using filters
      else {
        this.setFullTextFilter(queryParam.trim()).then(() => {
          if (this.isFiltersEmpty) {
            //this.resetObservations();
            //this.initFacets();
          } else {
            this.searchObservations(this.getFilters);
          }
        });
      }
    }
  }
};
</script>

<style>
.ui.action.left.icon.input {
  position: absolute;
  float: left;
  z-index: 999;
  margin-top: 20px;
  margin-left: 50px;
}
.ui.list {
  position: absolute;
  float: left;
  z-index: 999;
  margin-left: 50px;
  margin-top: 75px;
}
</style>
